import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.payou_order,
    props.app.buttons.create_payou_order,
    (order, button) => {
        return {
            order,
            button
        }
    }
)